import Router from 'next/router';
import { Message } from '@bijie/react-bnb';
import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import { eraseCookie, createCookie } from '../../utils/cookies-browser';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';
import clientCacheConfig from '../../config/clientCache';
import { getLoginUrl } from '../../utils/urlUtils';

const {
  FETCH_USER_INFO,
  SET_USER_INFO,
  SET_ANTI_CODE,
  FETCH_USER_INFO_ERROR,
  FETCH_KTC_INFO,
  FETCH_KTC_INFO_SUCCESS,
  FETCH_KTC_INFO_ERROR,
  SET_USER_LOGS,
  FETCH_USER_LOGS,
  FETCH_USER_LOGS_ERROR,
  FETCH_USER_CONFIG,
  FETCH_USER_CONFIG_SUCCESS,
  FETCH_USER_CONFIG_FAILED,
  SET_GOOGLE_AUTH_SECRET_KEY_DATA,
  FETCH_COUNTRY_SHORT_NAME_SUCCESS,
  FETCH_USER_AGENT_MESSAGE_SUCCESS,
  FETCH_USER_ANTI_PHISHING_CODE,
  SET_USER_ANTI_PHISHING_CODE,
  FETCH_USER_ANTI_PHISHING_CODE_ERROR,
  FETCH_TRADE_INFO_SUCCESS,
  UPDATA_USER_COMMISSION_STATUS_SUCCESS,
  FETCH_USER_TOTAL_COMMISSTION_SUCCESS,
  FETCH_USER_DEVICE_LIST_SUCCESS,
  FETCH_USER_DEVICE_LOG_SUCCESS,
  DELETE_USER_DEVICE_SUCCESS,
  UPDATE_USER_PASSWORD,
  UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS,
  FETCH_ACCOUNT_ACTIVITY_RECORD_SUCCESS,
  SET_TRADE_LEVEL_INFO,
  FETCH_USER_COMMISSTION_TOTAL,
  FETCH_USER_COMMISSTION_DETAIL,
  SET_TOP_COMMISSION,
  SET_BASE_DETAIL,
  SET_CONFIRM_TIPS,
} = actionTypes;

const setUserInfoData = createBaseActions(SET_USER_INFO, 'data');
const setAntiCode = createBaseActions(SET_ANTI_CODE, 'data');
const setKYCInfoData = createBaseActions(FETCH_KTC_INFO_SUCCESS, 'data');
const setUserLogsData = createBaseActions(SET_USER_LOGS, 'data');
const setUserConfigData = createBaseActions(FETCH_USER_CONFIG_SUCCESS, 'data');
const setGoogleAuthSecretKeyData = createBaseActions(SET_GOOGLE_AUTH_SECRET_KEY_DATA, 'data');
const setCountryShortName = createBaseActions(FETCH_COUNTRY_SHORT_NAME_SUCCESS, 'data');
const setUserAgentMessage = createBaseActions(FETCH_USER_AGENT_MESSAGE_SUCCESS, 'data');
const setUserAntiPhishingCode = createBaseActions(SET_USER_ANTI_PHISHING_CODE, 'data');
const setTradeInfoData = createBaseActions(FETCH_TRADE_INFO_SUCCESS, 'data');
const setUserCommissionStatus = createBaseActions(UPDATA_USER_COMMISSION_STATUS_SUCCESS, 'data');
const setUserTotalCommission = createBaseActions(FETCH_USER_TOTAL_COMMISSTION_SUCCESS, 'data');
const setUserDeviceList = createBaseActions(FETCH_USER_DEVICE_LIST_SUCCESS, 'data');
const setUserDeviceLog = createBaseActions(FETCH_USER_DEVICE_LOG_SUCCESS, 'data');
const updataDeviceList = createBaseActions(DELETE_USER_DEVICE_SUCCESS, 'data');
const updataWithdrawWhiteStatus = createBaseActions(UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS, 'data');
const setAccountActivityRecordList = createBaseActions(
  FETCH_ACCOUNT_ACTIVITY_RECORD_SUCCESS,
  'data'
);
export const setTradeLevelInfo = createBaseActions(SET_TRADE_LEVEL_INFO, 'data');

const setUserCommissionTotal = createBaseActions(FETCH_USER_COMMISSTION_TOTAL, 'data');
const setUserCommissionDetail = createBaseActions(FETCH_USER_COMMISSTION_DETAIL, 'data');
const setTopCommission = createBaseActions(SET_TOP_COMMISSION, 'data');
const setConfirmTips = createBaseActions(SET_CONFIRM_TIPS, 'data');
const setBaseDetail = createBaseActions(SET_BASE_DETAIL, 'data');

// const setCom

const fetchUserAntiPhishingCodeError = createBaseActions(
  FETCH_USER_ANTI_PHISHING_CODE_ERROR,
  'error'
);

const handleUserInfo = data => {
  data = handleGwData(data) || {};
  return {
    ...data,
    isParentUser: data.parentUser,
    isSubUser: data.subUser,
    isExistMarginAccount: data.isExistMarginAccount,
    isSubUserEnabled: data.subUserEnabled,
    userData: {
      authenticationType: data.authenticationType,
      commissionStatus: data.commissionStatus,
      userId: data.userId,
    },
  };
};

export const fetchBaseDetail = async (locale, withClientApiCache) => {
  let result = {};
  try {
    result = await gwPost(
      API_PATH.USER_INFO_API_PATH,
      { locale, ...setPostBody() },
      null,
      true,
      {
        withClientApiCache,
        expire: clientCacheConfig.userInfo,
      }
    );
    result = handleUserInfo(result);
  } catch (error) {
    bog.error(`Error: fetchBaseDetail error, message is ${error.message}`);
  }
  return result;
};

export const fetchAntiCode = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.ANTI_PHISHING_CODE_API_PATH, { locale, ...setPostBody() });
    dispatch(setAntiCode(result?.data));
  } catch (error) {
    bog.error(`Error: fetchAntiCode error, message is ${error.message}`);
  }
};

export const fetchUserInfo = withClientApiCache => async (dispatch, getState) => {
  dispatch({ type: FETCH_USER_INFO });
  const { locale } = getState();
  try {
    const userInfo = await fetchBaseDetail(locale, withClientApiCache);
    dispatch(setUserInfoData(userInfo));
  } catch (error) {
    dispatch({ type: FETCH_USER_INFO_ERROR, error });
  }
};

export const getKycInfoRequest = () => gwPost(API_PATH.GET_KYC_VALIDATE_INFO_API, setPostBody());

export const fetchKycInfo = withClientApiCache => async dispatch => {
  dispatch({ type: FETCH_KTC_INFO });
  try {
    const data = await gwPost(
      API_PATH.GET_CURRENT_KYC_VALIDATE_INFO_API,
      {},
      null,
      true,
      {
        withClientApiCache,
        expire: clientCacheConfig.kyc,
      }
    );
    dispatch(setKYCInfoData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_KTC_INFO_ERROR, error });
  }
};

export const fetchUserLogs = (postData, locale) => async dispatch => {
  dispatch({ type: FETCH_USER_LOGS });
  try {
    const data = await gwPost(API_PATH.USER_LOGS_API_PATH, { locale, ...setPostBody(postData) });
    dispatch(setUserLogsData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_USER_LOGS_ERROR, error });
  }
};

export const getUserConfigRequest = req => gwPost(API_PATH.GET_USER_CONFIG_API, setPostBody(), req);

export const fetchUserConfig = () => async dispatch => {
  dispatch({ type: FETCH_USER_CONFIG });
  try {
    const data = await getUserConfigRequest();
    dispatch(setUserConfigData(handleGwData(data)));
  } catch (error) {
    dispatch({ type: FETCH_USER_CONFIG_FAILED, error });
  }
};

export const openWhiteListStatus = data => async dispatch => {
  const params = {
    authType: data.type,
    verifyCode: data.code,
  };
  try {
    const result = await gwPost(API_PATH.OPEN_WITHDRAW_WHITE_STATUS_API_PATH, setPostBody(params));
    if (result.success) {
      dispatch(updataWithdrawWhiteStatus(true));
      return Promise.resolve();
    }
    Message.fail(result.message, 3);
    return Promise.reject();
  } catch (error) {
    return Promise.reject();
  }
};

export const fetchSecretKey = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.GENERATE_SECRET_KEY_API, { locale, ...setPostBody() });
    if (result.success) {
      dispatch(setGoogleAuthSecretKeyData(result.data));
    }
  } catch (error) {
    throw error;
  }
};

export const fetchCountryShortName = () => async dispatch => {
  try {
    const result = await gwGet(API_PATH.GET_COUNTRY_SHORT_NAME);
    if (result.success) {
      dispatch(setCountryShortName(result.data));
    }
  } catch (error) {
    throw error;
  }
};

export const fetchUserAgentMessage = params => async dispatch => {
  try {
    const result = await gwPost(API_PATH.USER_AGENT_MESSAGE, setPostBody(params));
    if (result.success) {
      dispatch(setUserAgentMessage(result.data));
    }
  } catch (error) {
    throw error;
  }
};

export const closeWhiteListStatus = data => async (dispatch, getState) => {
  const { locale } = getState();
  const api = API_PATH.CLOSE_WITHDRAW_WHITE_STATUS_API_PATH;

  const params = {
    authType: data.type,
    verifyCode: data.code,
  };
  try {
    const result = await gwPost(api, setPostBody(params));
    if (result.success) {
      Router.push(`/${locale}/usercenter/security/disable-withdraw-whiteList`);
      return Promise.resolve();
    }
    Message.fail(result.message, 3);
    return Promise.reject();
  } catch (error) {
    return Promise.reject();
  }
};

export const updateUserConfigRequest = data => {
  if (data.configType === 'language') {
    const saveLocale = data.configName || 'en';
    eraseCookie('lang');
    createCookie('lang', saveLocale.toLowerCase(), 365, true);
  }
  return gwPost(API_PATH.SAVE_USER_CONFIG_API_PATH, setPostBody(data));
};

export const fetchUserAntiPhishingCode = locale => async dispatch => {
  dispatch({ type: FETCH_USER_ANTI_PHISHING_CODE });
  try {
    const api = API_PATH.ANTI_PHISHING_CODE_API_PATH;
    const data = await gwPost(api, { locale, ...setPostBody() });
    dispatch(setUserAntiPhishingCode(handleGwData(data)));
  } catch (error) {
    dispatch(fetchUserAntiPhishingCodeError(error));
  }
};

export const sendSmsCode = async locale => {
  const postData = setPostBody();
  const result = await gwPost(API_PATH.SEND_SMS_CODE_API_PATH, { locale, ...postData });
  return result;
};

export const updateCommissionStatus = status => async (dispatch, getState) => {
  const { locale } = getState();
  const postData = setPostBody({
    useBnbFee: status,
  });
  const api = API_PATH.SET_COMMISSION_STATUS_API_PATH;
  const result = await gwPost(api, { locale, ...postData });
  if (result.success) {
    dispatch(setUserCommissionStatus(status));
  }
};

export const fetchTradeLevelInfo = async (req, locale) => {
  let result = [];
  try {
    const api = API_PATH.TRADE_LEVEL_API_PATH;
    result = await makeOrCacheApiReq(
      api,
      () => gwGet(api, { locale }, req),
      res => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (e) {
    // nothing
  }
  return result;
};

export const fetchTradeNumber = () => async dispatch => {
  let result = {};
  try {
    result = await gwPost(API_PATH.TRADE_INFO_API_PATH);
    if (result.success) {
      dispatch(setTradeInfoData(result.data));
    }
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchUserTotalCommission = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.COMMISSION_TOTAL_PATH, {
      locale,
      ...setPostBody(),
    });
    if (result.data) {
      dispatch(setUserTotalCommission(result.data.total));
    }
  } catch (error) {
    bog.error(`Error: fetchTradeNumber error, message is ${error.message}`);
  }
};

export const fetchDeviceList = (req, callback) => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.USER_DEVICE_LIST_API_PATH, {
      locale,
      ...setPostBody({ ...req }),
    });
    if (result.data) {
      dispatch(setUserDeviceList(result));
      callback();
    }
  } catch (error) {
    bog.error(`Error: fetch user device list error, message is ${error.message}`);
  }
};

export const fetchDeviceLogById = (data, callback) => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.FETCH_USER_DEVICE_LOG_API_PATH, {
      locale,
      ...setPostBody({ ...data }),
    });
    if (result.success) {
      dispatch(setUserDeviceLog({ id: data.devicePk, data: result }));
      callback();
    }
  } catch (error) {
    bog.error(`Error: fetch user device log error, message is ${error.message}`);
  }
};

export const deleteDevice = (deviceId, id, callback) => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.DELETE_USER_DEVICE_API_PATH, {
      locale,
      ...setPostBody({ deviceId, devicePk: id }),
    });
    if (result.success) {
      dispatch(updataDeviceList(id));
      callback();
    }
  } catch (error) {
    bog.error(`Error: delete user device error, message is ${error.message}`);
  }
};

export const fetchAccountActivityRecord = postData => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.FETCH_ACCOUNT_ACTIVITY_RECORD, {
      locale,
      ...setPostBody(postData),
    });
    if (result.data) {
      dispatch(setAccountActivityRecordList(result.data));
    }
  } catch (error) {
    bog.error(`Error: fetch user device list error, message is ${error.message}`);
  }
};

export const disableAccount = () => async (dispatch, getState) => {
  const { locale } = getState();
  const postData = setPostBody();
  try {
    const result = await gwPost(API_PATH.DISABLE_ACCOUNT, { locale, ...postData });
    if (result.success) {
      window.location.href = getLoginUrl(locale);
    }
  } catch (error) {
    bog.error(`Error: disable account error, message is ${error.message}`);
  }
};

export const updatePassword = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.USER_UPDATE_PASSWORD_API, {
      locale,
      ...setPostBody({ ...data }),
    });
    dispatch({ type: UPDATE_USER_PASSWORD, data: result });
    return result;
  } catch (error) {
    bog.error(`Error: delete user device error, message is ${error.message}`);
  }
  return {};
};

export const fetchCommissionDetail = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.COMMISSION_DETAIL_PATH, {
      locale,
      ...setPostBody({ page: 1, rows: 30 }),
    });
    result = handleGwData(result) || {};
    dispatch(setUserCommissionDetail(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const getTopCommission = () => async dispatch => {
  try {
    let result = await gwGet(API_PATH.COMMISSION_TOP_PATH);
    result = handleGwData(result) || {};
    dispatch(setTopCommission(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const fetchCommissionRate = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.USER_INFO_API_PATH, { locale, ...setPostBody() });
    result = handleGwData(result) || {};
    dispatch(setBaseDetail(result));
  } catch (error) {
    bog.error(`Error: fetchBaseDetail error, message is ${error.message}`);
  }
};

export const updateConfirmTips = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.CONFIRM_TIP, { locale, ...setPostBody({}) });
    result = handleGwData(result) || {};
    dispatch(setConfirmTips(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const setCoinApply = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.COIN_APPLY_PATH, {
      locale,
      ...setPostBody({ ...data }),
    });
    return result;
  } catch (error) {
    bog.error(`Error: set coin apply error, message is ${error.message}`);
  }
  return {};
};

export const fetchCommissionTotal = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    let result = await gwPost(API_PATH.COMMISSION_TOTAL_PATH, { locale, ...setPostBody() });
    result = handleGwData(result) || {};
    dispatch(setUserCommissionTotal(result));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};
